document.addEventListener("DOMContentLoaded", function() {
    function moveElementForMobile() {
        // Get the elements
        const headerCapture = document.querySelector('.pr_header_capture');
        const targetContainer = document.querySelector('.product-single__header--mobile.medium-up--hide');
        
        // Check if elements exist
        if (headerCapture && targetContainer) {
            // Check if the viewport width is less than or equal to 768px (mobile view)
            if (window.innerWidth <= 768) {
                // Move the headerCapture inside the targetContainer
                targetContainer.appendChild(headerCapture);
            }
        }
    }

    // Initial check when the DOM is fully loaded
    moveElementForMobile();
    
    // Add an event listener for window resize to recheck on resize
    window.addEventListener('resize', moveElementForMobile);
});